module.exports = __webpack_public_path__ + "img/bank-transfer.012b4f0b.png";